<template>
  <div class="col-12 col-xl-12 col-md-12" v-if="prescription">
    <!-- Editable -->
    <div v-if="editable">
      <form>
        <!-- Private Notes -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('privateNotes') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Private Notes") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input>
              <textarea v-model="prescription.privateNotes" :placeholder="$t('message.Private Notes is only visible to you This notes is not shared with the patient')"></textarea>
            </fg-input>
          </div>
        </div>

        <!-- Descriptive Notes -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('descriptiveNotes') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Descriptive Notes") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input :placeholder="$t('message.Descriptive Notes')">
              <textarea v-model="prescription.descriptiveNotes" :placeholder="$t('message.Descriptive Notes')"></textarea>
            </fg-input>
          </div>
        </div>

        <!-- Chief Complaints -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('chiefComplaints') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Chief Complaints") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input :placeholder="$t('message.Chief Complaints')">
              <textarea v-model="prescription.chiefComplaints" :placeholder="$t('message.Chief Complaints')"></textarea>
            </fg-input>
          </div>
        </div>

        <!-- Relevant Points from History -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('relevantPointsfromHistory') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Relevant Points from History") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input :placeholder="$t('message.Relevant Points from History')">
              <textarea v-model="prescription.relevantPointsfromHistory" :placeholder="$t('message.Relevant Points from History')"></textarea>
            </fg-input>
          </div>
        </div>

        <!-- Examination/Lab Findings -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('labFindings') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Examination/Lab Findings") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input :placeholder="$t('message.Examination/Lab Findings')">
              <textarea v-model="prescription.labFindings" :placeholder="$t('message.Examination/Lab Findings')"></textarea>
            </fg-input>
          </div>
        </div>

        <!-- Diagnosis or Provisional Diagnosis -->
        <div v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('provisionalDiagnosis') > -1)">
          <div class="row prescription-section">
            <div class="col-md-12">
              <h6>{{ $t("message.Diagnosis or Provisional Diagnosis") }}</h6>
            </div>
            <div class="col-md-12">
              <fg-input type="text" :label="$t('message.Notes')" v-model="prescription.provisionalDiagnosis.notes" :placeholder="$t('message.Provisonal Notes')"></fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-1">
              <label>{{ $t("message.ICD Codes") }}</label>
            </div>
            <div class="col-md-12" v-if="prescription.provisionalDiagnosis">
              <card v-for="(icd, index) in prescription.provisionalDiagnosis.icdCodes" :key="icd.Code" cardBodyClasses="pt-1">
                <div class="row">
                  <n-button type="danger" social icon round size="sm" @click.native="removeIcdCodeCard(index)" style="
                    position: absolute;
                    inset-inline-end: 0.5em;
                    top:0;
                    z-index: 1;
                  ">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                  </n-button>
                  <div class="col-12 col-md-12">
                    <label for="">{{ $t('message.Code') }}</label>
                    <div>{{ icd.Code }}</div>
                  </div>
                  <div class="col-12 col-md-12">
                    <label for="">{{ $t('message.Description') }}</label>
                    <div>{{ icd.Description }}</div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-md-12 text-center">
              <n-button type="primary" simple round @click.native="addNewICDcode()">
                <i class="fa fa-plus pr-1"></i>
                {{ $t("message.Add ICD") }}
              </n-button>
            </div>
          </div>
        </div>

        <!-- RX Prescription -->
        <div v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('rx') > -1)">
          <div class="row prescription-section">
            <div class="col-md-12">
              <h6>{{ $t("message.RX Prescription") }}</h6>
            </div>
          </div>
          <div v-if="prescription.rx">
            <card v-for="(rx, index) in prescription.rx" :key="rx.xyz" cardBodyClasses="pt-1">
              <div style="font-size: small">
                <div class="mb-1">{{ rx.dosageForm || rx.dosageName }}</div>
                <div class="pl-0 pr-0 col-11">
                  <p>{{ rx.name }}</p>
                </div>
                <div>{{ rx.routeOfAdministration }}</div>
                <div> {{ rx.frequency ? ((rx.frequency.durationNo || rx.frequency.duration == 'Till Next Visit') ? ((rx.frequency.duration != 'Till Next Visit' && rx.frequency.duration) ? 'For ' + (rx.frequency.durationNo ? rx.frequency.durationNo + " - " + rx.frequency.duration + " " : "") : rx.frequency.duration) : "") + (rx.frequency.day ? " " + rx.frequency.day : "") : "" }} </div>
                <div>{{ rx.instruction }}</div>
                <div style="display: flex; justify-content: space-between;">
                  <div> {{ rx.frequency && rx.frequency.when ? ((rx.frequency.minutes ? rx.frequency.minutes + " Mins " : "") + (rx.frequency.when ? "- " + rx.frequency.when : "")) : "" }} </div>
                  <div class="d-flex">
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        M
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ rx.frequency ? (rx.frequency.morning ? (rx.frequency.morning.nos ? rx.frequency.morning.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        A
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ rx.frequency ? (rx.frequency.afternoon ? (rx.frequency.afternoon.nos ? rx.frequency.afternoon.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        E
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ rx.frequency ? (rx.frequency.evening ? (rx.frequency.evening.nos ? rx.frequency.evening.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        N
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ rx.frequency ? (rx.frequency.night ? (rx.frequency.night.nos ? rx.frequency.night.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                  </div>
                </div>
                <n-button type="danger" size="sm" social icon round @click.native="deleteDrugCard(index)" style="
                    position: absolute;
                    inset-inline-end: 0.5em;
                    top:0;
                    margin-top: 0.2em;
                    z-index: 1;
                  ">
                  <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                </n-button>
              </div>
            </card>
          </div>
          <div class="text-center">
            <n-button type="primary" simple round @click.native="addNewRx()">
              <i class="fa fa-plus pr-1"></i>
              {{ $t("message.Add RX") }}
            </n-button>
          </div>
        </div>

        <!-- Lab Prescription -->
        <div v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('lab') > -1)">
          <div class="row prescription-section">
            <div class="col-md-12">
              <h6>{{ $t("message.Lab Prescription") }}</h6>
              <div class="row">
                <div class="col-12">
                </div>
              </div>
            </div>
          </div>
          <div v-if="prescription.labPrescription">
            <card v-for="(labTest, index) in prescription.labPrescription" :key="labTest.xyz" cardBodyClasses="pt-1">
              <div class="row">
                <n-button type="danger" size="sm" social icon round @click.native="deleteLabCard(index)" style="
                    position: absolute;
                    inset-inline-end: 0.5em;
                    top:0;
                    z-index: 1;
                  ">
                  <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                </n-button>
                <div class="col-12 col-md-12">
                  <label for="">{{ $t('message.Test') }}</label>
                  <div> {{ labTest.test }}</div>
                </div>
                <div class="col-12 col-md-12">
                  <label for="">{{ $t('message.Comment :') }}</label>
                  <div> {{ labTest.comment }}</div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-md-12 text-center">
            <n-button type="primary" simple round @click.native="addNewLabPrescription()">
              <i class="fa fa-plus pr-1"></i>
              {{ $t("message.Add Lab Test") }}
            </n-button>
          </div>
        </div>

        <!-- Imaging Prescription -->
        <div v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('imaging') > -1)">
          <div class="row prescription-section">
            <div class="col-12">
              <h6>{{ $t("message.Imaging Prescription") }}</h6>
            </div>
          </div>
          <div v-if="prescription.imagingPrescription">
            <card v-for="imagingType in prescription.imagingPrescription.types" class="card-nav-tabs" header-classes="card-header-warning" :key="imagingType.type">
              <div slot="header">{{ imagingType.type }}</div>
              <div class="row">
                <n-button type="danger" size="sm" social icon round @click.native="removeImagingType(imagingType.type, imagingType.type)" style="
                    position: absolute;
                    inset-inline-end: 0.5em;
                    top:0;
                    z-index: 1;
                  ">
                  <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                </n-button>
                <div class="col-12">
                  <div>
                    <dynamic-image v-if="imagingType.imageData" :file-id="imagingType.imageData">
                    </dynamic-image>
                  </div>
                  <div class="row" style="font-size: small">
                    <div class="col-12" v-for="option in imagingType.option" :key="option">
                      <i class="fa fa-check-square"></i>
                      {{ option }}
                    </div>
                    <span v-if="imagingType.comment" class="col-12">
                      <span>{{ $t("message.Comment :") }}</span>
                      {{ imagingType.comment }}
                    </span>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-md-12 text-center">
            <n-button type="primary" simple round @click.native="addNewImagingPrescription()">
              <i class="fa fa-plus pr-1"></i>
              {{ $t("message.Add Imaging") }}
            </n-button>
          </div>
        </div>
        <!-- Attachments -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('attachments') > -1)">
          <div class="col-12">
            <h6>{{ $t("message.Attachments") }}</h6>
          </div>

          <div v-if="prescription.attachments && prescription.attachments.length > 0">

            <div class="col-12" v-for="(attachment, index) in prescription.attachments" :key="index">
              <card>
                <div class="row">
                  <!-- Thumbnail -->
                  <div class="col-2 pr-0">
                    <dynamic-image v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId">
                    </dynamic-image>
                    <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i>
                  </div>
                  <div @click="viewFile(attachment)" class="col-8" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;margin: auto;">
                    {{ attachment.name }}
                  </div>
                  <div class="col-2 col-md-2 col-lg-2" style="color: red;margin:auto;" @click="deleteFile(attachment, index)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <!-- Button -->
        <div style="display: flex;flex-direction: row;justify-content: center;">
          <div>
            <n-button type="primary" simple round @click.native="browseFiles">
              <i class="fa fa-upload pr-1"></i>
              {{ $t("message.Select") }}
            </n-button>
          </div>
          <div style="margin: 1.2em 0.5em;">
            <span>{{ $t("message.OR") }}</span>
          </div>
          <div>
            <n-button type="primary" simple round @click.native="initiateOpenCamera">
              <i class="fa fa-camera pr-1"></i>
              {{ $t("message.Capture") }}
            </n-button>
          </div>
        </div>

        <!-- Other Comments-->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('comments') > -1)">
          <div class="col-md-12">
            <h6>{{ $t("message.Other Comments") }}</h6>
          </div>
          <div class="col-md-12">
            <fg-input type="text" v-model="prescription.otherComments" :placeholder="$t('message.Comments')"></fg-input>
          </div>
        </div>

        <!-- Follow up -->
        <!-- v-if="prescription.followup" -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('followup') > -1)">
          <div class="col-md-12">
            <h6>{{ $t("message.Follow up") }}</h6>
          </div>
          <div class="col-md-12 mb-3">
            <n-checkbox v-model="prescription.followup.requested">{{
              $t("message.Request")
            }}</n-checkbox>
          </div>
          <div class="col-md-12" v-if="prescription.followup.requested">
            <div class="row">
              <div class="col-2" style="line-height: 32px">
                {{ $t("message.After") }}
              </div>
              <div class="col-3">
                <fg-input type="number" v-model="prescription.followup.durationNo" :placeholder="$t('message.No(number)')" id="followup-days"></fg-input>
              </div>
              <div class="col-7">
                <el-select class="select-primary form-group" size="large" :label="$t('message.Drug Form')" :placeholder="$t('message.Duration')" v-model="prescription.followup.duration">
                  <el-option value="days" :label="$t('message.Day(s)')"></el-option>
                  <el-option value="weeks" :label="$t('message.Week(s)')"></el-option>
                  <el-option value="months" :label="$t('message.Months')"></el-option>
                </el-select>
              </div>
              <div class="col-12">
                <fg-input type="text" v-model="prescription.followup.comments" :placeholder="$t('message.Comments')"></fg-input>
              </div>
            </div>
          </div>
        </div>

        <!-- Emergency Care -->
        <div class="row prescription-section" v-if="(user.notesAndPrescriptionSections && user.notesAndPrescriptionSections.indexOf('emergencyCare') > -1)">
          <div class="col-12 col-md-12">
            <h6>{{ $t("message.Emergency Care") }}</h6>
          </div>
          <div class="col-12 col-md-12">
            <fg-input :placeholder="$t('message.Emergency Care')">
              <textarea v-model="prescription.emergencyCare" :placeholder="$t('message.When and how to seek emergency care')"></textarea>
            </fg-input>
          </div>
        </div>

      </form>

      <!-- ICD selction modal-->
      <modal :show.sync="SHOW_ICD_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onIcdSelectionModalClosed()">
        <h6 slot="header" class="title title-up">{{ $t("message.Select ICD") }}</h6>
        <div class="row" v-if="!selectedIcd">
          <div class="col-12 pl-5 pr-5">
            <cool-select class="custom-input" :placeholder="$t('message.Search ICD Codes')" :items="icdCodesList" disable-filtering-by-search @select="selectIcdCode" @search="searchIcdCodes" item-value="Code" item-text="Code" ref="icd-autocomplete" :search-text.sync="icdCodesSearchText">
              <template #no-data>
                {{ ICD_CODE_NOT_FOUND ? $t("message.No ICD Code found") : "" }}
              </template>
              <template slot="item" slot-scope="{ item }">
                <div class="row">
                  <div class="pr-1 col-11 autocomplete-result">
                    <span class="item-name">{{ item.Code }} - {{ item.Description }}</span>
                  </div>
                  <div class="pl-0 col-1 autocomplete-result" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </template>
            </cool-select>
          </div>
        </div>
        <div class="row pl-3 pr-3" v-if="selectedIcd">
          <card>
            <div class="row">
              <n-button type="danger" social icon round @click.native="deleteSelectedIcd()" style="
                    position: absolute;
                    inset-inline-end: 1em;
                    top:0
                    z-index: 1;
                  ">
                <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
              </n-button>
              <div class="col-12 col-md-12 mt-3">
                <fg-input type="text" style="margin-top: 2em;" :label="$t('message.Code')" v-model="selectedIcd.Code"></fg-input>
              </div>
              <div class="col-12 col-md-12">
                <fg-input type="text" :label="$t('message.Description')" v-model="selectedIcd.Description"></fg-input>
              </div>
            </div>
          </card>
        </div>
        <template slot="footer">
          <div v-if="selectedIcd" class="text-center" style="width: 100%;">
            <n-button type="primary" round @click.native="addIcdToPrescription(selectedIcd)">
              <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
            </n-button>
          </div>
        </template>
      </modal>

      <!-- RX selction modal-->
      <modal :show.sync="SHOW_RX_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onRxSelectionModalClosed()">
        <h6 slot="header" class="title title-up">{{ $t("message.Select RX") }}</h6>
        <div class="row" v-if="!selectedRX">
          <div class="col-12 pl-5 pr-5">
            <cool-select class="custom-input" :placeholder="$t('message.Search Drugs')" :items="drugList" @select="selectDrugs" disable-filtering-by-search @search="searchDrugs" item-text="substanceName" :search-text.sync="drugsSearchText">
              <template #no-data>
                {{ DRUG_NOT_FOUND ? $t("message.No drug found") : "" }}
              </template>
              <template slot="item" slot-scope="{ item }">
                <div class="row">
                  <div class="pr-1 col-11 autocomplete-result">
                    <span class="item-name">{{ item.substanceName }} - {{ item.dosageFormName }}
                    </span>
                  </div>
                  <div class="pl-0 col-1 autocomplete-result" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </template>
            </cool-select>
          </div>
          <div style="padding-top: 15px; padding-left: 82px">
            <span>{{ $t("message.OR") }}</span>
          </div>
          <n-button type="primary" round style="margin-left: 15px" @click.native="addNewDrugCard()">{{ $t("message.Add New") }}</n-button>
        </div>
        <div class="row pl-3 pr-3" v-if="selectedRX">
          <card>
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="row">
                  <div class="col-md-8 col-9">
                    <el-select class="select-primary" size="large" :label="$t('message.Drug Form')" :placeholder="$t('message.Drug Form')" v-model="selectedRX.dosageForm">
                      <el-option disabled value="null">{{
                        $t("message.Drug Form")
                      }}</el-option>
                      <el-option class="select-primary" value="TABLET" :label="$t('message.Tablet')"></el-option>
                      <el-option class="select-primary" value="CAPSULE" :label="$t('message.Capsule')"></el-option>
                      <el-option class="select-primary" value="SOLUTION" :label="$t('message.Solution')"></el-option>
                      <el-option class="select-primary" value="POWDER" :label="$t('message.Powder')"></el-option>
                      <el-option class="select-primary" value="SYRUP" :label="$t('message.Syrup')"></el-option>
                      <el-option class="select-primary" value="PILL" :label="$t('message.Pill')"></el-option>
                      <el-option class="select-primary" value="LOTION" :label="$t('message.Lotion')"></el-option>
                      <el-option class="select-primary" value="GELL" :label="$t('message.Gel')"></el-option>
                      <el-option class="select-primary" value="CREAM" :label="$t('message.Cream')"></el-option>
                      <el-option class="select-primary" value="DROPS" :label="$t('message.Drops')"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-1 col-1 pl-0">
                    <n-button type="danger" social icon round @click.native="deleteSelectedRx()">
                      <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                    </n-button>
                  </div>
                  <div class="col-md-1 col-1" v-show="!selectedRX._id">
                    <n-button type="primary" social icon round @click.native="addNewDrug(selectedRX)">
                      <i class="fa fa-save"></i>
                    </n-button>
                  </div>
                  <div class="col-md-1 col-1" v-show="selectedRX._id">
                    <n-button :type="isFrequentDrug(selectedRX._id) ? 'warning' : 'default'" social icon round @click.native="toggleFrequentDrug(selectedRX._id)">
                      <i class="fa fa-star"></i>
                    </n-button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row">
                  <div class="col-md-6 col-6">
                    <fg-input type="text" :label="$t('message.Drug Name')" :placeholder="$t('message.Drug Name')" v-model="selectedRX.name"></fg-input>
                  </div>
                  <div class="col-md-6 col-6">
                    <el-select class="select-primary" size="large" :label="$t('message.Dosage')" :placeholder="$t('message.Dosage')" v-model="selectedRX.dosage" style="margin-top: 15px">
                      <el-option disabled value="null">{{
                        $t("message.Dosage")
                      }}</el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(0, 0, 0)" value="0,0,0" label="0-0-0"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(0, 0, 1)" value="0,0,1" label="0-0-1"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(0, 1, 0)" value="0,1,0" label="0-1-0"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(0, 1, 1)" value="0,1,1" label="0-1-1"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(1, 0, 0)" value="1,0,0" label="1-0-0"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(1, 0, 1)" value="1,0,1" label="1-0-1"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(1, 1, 0)" value="1,1,0" label="1-1-0"></el-option>
                      <el-option class="select-primary" @click.native="updateFrequency(1, 1, 1)" value="1,1,1" label="1-1-1"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row dosage-frequency">
                  <div class="col-md-3 col-3">
                    <label>{{ $t('message.Morning') }}</label>
                    <el-select class="select-primary mt-0" size="large" :label="$t('message.Morning')" placeholder="" v-model="selectedRX.frequency.morning.nos" style="margin-top: 15px">
                      <el-option disabled value="null">{{ $t('message.Morning') }}</el-option>
                      <el-option class="select-primary" value="0.5" label="0.5"></el-option>
                      <el-option class="select-primary" value="1" label="1"></el-option>
                      <el-option class="select-primary" value="2" label="2"></el-option>
                      <el-option class="select-primary" value="3" label="3"></el-option>
                      <el-option class="select-primary" value="4" label="4"></el-option>
                      <el-option class="select-primary" value="5" label="5"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-3 col-3">
                    <label>{{ $t('message.Afternoon') }}</label>
                    <el-select class="select-primary mt-0" size="large" :label="$t('message.Afternoon')" placeholder="" v-model="selectedRX.frequency.afternoon.nos" style="margin-top: 15px">
                      <el-option disabled value="null">{{ $t('message.Afternoon') }}</el-option>
                      <el-option class="select-primary" value="0.5" label="0.5"></el-option>
                      <el-option class="select-primary" value="1" label="1"></el-option>
                      <el-option class="select-primary" value="2" label="2"></el-option>
                      <el-option class="select-primary" value="3" label="3"></el-option>
                      <el-option class="select-primary" value="4" label="4"></el-option>
                      <el-option class="select-primary" value="5" label="5"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-3 col-3">
                    <label>{{ $t('message.Evening') }}</label>
                    <el-select class="select-primary mt-0" size="large" :label="$t('message.Evening')" placeholder="" v-model="selectedRX.frequency.evening.nos" style="margin-top: 15px">
                      <el-option disabled value="null">{{ $t('message.Evening') }}</el-option>
                      <el-option class="select-primary" value="0.5" label="0.5"></el-option>
                      <el-option class="select-primary" value="1" label="1"></el-option>
                      <el-option class="select-primary" value="2" label="2"></el-option>
                      <el-option class="select-primary" value="3" label="3"></el-option>
                      <el-option class="select-primary" value="4" label="4"></el-option>
                      <el-option class="select-primary" value="5" label="5"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-3 col-3">
                    <label>{{ $t('message.Night') }}</label>
                    <el-select class="select-primary mt-0" size="large" :label="$t('message.Night')" placeholder="" v-model="selectedRX.frequency.night.nos" style="margin-top: 15px">
                      <el-option disabled value="null">{{ $t('message.Night') }}</el-option>
                      <el-option class="select-primary" value="0.5" label="0.5"></el-option>
                      <el-option class="select-primary" value="1" label="1"></el-option>
                      <el-option class="select-primary" value="2" label="2"></el-option>
                      <el-option class="select-primary" value="3" label="3"></el-option>
                      <el-option class="select-primary" value="4" label="4"></el-option>
                      <el-option class="select-primary" value="5" label="5"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <el-select class="select-primary" size="large" :label="$t('message.Route of Administration')" :placeholder="$t('message.Route of Administration')" v-model="selectedRX.routeOfAdministration">
                  <el-option disabled value="null">{{
                    $t("message.Route of Administration")
                  }}</el-option>
                  <el-option v-for="routeOfAdministration in routesOfAdministration" :key="routeOfAdministration" class="select-primary" :value="routeOfAdministration" :label="routeOfAdministration"></el-option>
                </el-select>
              </div>
              <div class="col-md-12 col-12">
                <div class="row">
                  <div class="col-md-4 col-4">
                    <el-select class="select-primary" size="large" :label="$t('message.Duration')" :placeholder="$t('message.Duration')" v-model="selectedRX.frequency.duration" style="margin-top: 15px">
                      <el-option disabled value="null">{{
                        $t("message.Duration")
                      }}</el-option>
                      <el-option class="select-primary" value="Days" :label="$t('message.Day(s)')"></el-option>
                      <el-option class="select-primary" value="Weeks" :label="$t('message.Week(s)')"></el-option>
                      <el-option class="select-primary" value="Months" :label="$t('message.Months')"></el-option>
                      <el-option class="select-primary" value="Till Next Visit" :label="$t('message.Till Next Visit')"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-4 col-4">
                    <fg-input type="number" :placeholder="$t('message.No(number)')" v-model="selectedRX.frequency.durationNo" style="margin-top: 27px"></fg-input>
                  </div>
                  <div class="col-md-4 col-4">
                    <el-select class="select-primary" size="large" :label="$t('message.Day(s)')" :placeholder="$t('message.Day(s)')" v-model="selectedRX.frequency.day" style="margin-top: 15px">
                      <el-option disabled value="null">{{
                        $t("message.Day(s)")
                      }}</el-option>
                      <el-option class="select-primary" value="EveryDay" :label="$t('message.Everyday')"></el-option>
                      <el-option class="select-primary" value="Alternate Days" :label="$t('message.Alternate Days')"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row">
                  <div class="col-md-6 col-6">
                    <fg-input type="number" :label="$t('message.Minute')" :placeholder="$t('message.Minute')" v-model="selectedRX.frequency.minutes"></fg-input>
                  </div>
                  <div class="col-md-6 col-6">
                    <el-select class="select-primary" size="large" :label="$t('message.When')" :placeholder="$t('message.When')" v-model="selectedRX.frequency.when" style="margin-top: 15px">
                      <el-option disabled value="null">{{
                        $t("message.When")
                      }}</el-option>
                      <el-option class="select-primary" value="Before Food" :label="$t('message.Before Food')"></el-option>
                      <el-option class="select-primary" value="After Food" :label="$t('message.After Food')"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <fg-input type="Text" :label="$t('message.Instructions')" v-model="selectedRX.instruction" :placeholder="$t('message.Instructions')"></fg-input>
              </div>
            </div>
          </card>
        </div>
        <template slot="footer">
          <div v-if="selectedRX" class="text-center" style="width: 100%;">
            <n-button type="primary" round @click.native="addDrugToPrescription(selectedRX)">
              <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
            </n-button>
          </div>
        </template>
      </modal>

      <!-- Lab Tests selction modal-->
      <modal :show.sync="SHOW_LABTEST_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onLabTestSelectionModalClosed()">
        <h6 slot="header" class="title title-up">{{ $t("message.Select Lab Test") }}</h6>
        <div class="row" v-if="!selectedLabTest">
          <div class="col-12 pl-5 pr-5">
            <cool-select class="custom-input" :placeholder="$t('message.Search Lab Tests')" :items="labTestList" disable-filtering-by-search @select="selectLabTests" @search="searchLabTests" item-value="name" item-text="name" ref="lab-autocomplete" :search-text.sync="labTestsSearchText">
              <template #no-data>
                {{ LAB_TEST_NOT_FOUND ? $t("message.No lab test found") : "" }}
              </template>
              <template slot="item" slot-scope="{ item }">
                <div class="row">
                  <div class="pr-1 col-11 autocomplete-result">
                    <span class="item-name">{{ item.name }}</span>
                  </div>
                  <div class="pl-0 col-1 autocomplete-result" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </template>
            </cool-select>
          </div>
          <div style="padding-top: 15px; padding-left: 82px">
            <span>{{ $t("message.OR") }}</span>
          </div>
          <n-button type="primary" round style="margin-left: 15px" @click.native="addNewLabTestCard()">{{ $t("message.Add New") }}</n-button>
        </div>

        <div class="row pl-3 pr-3" v-if="selectedLabTest">
          <div class="col-12">
            <card>
              <div class="row">
                <div class="d-flex" style="position: absolute;top: 0;inset-inline-end: 0.5em;">
                  <n-button type="danger" class="mr-1" social icon round @click.native="deleteSelectedLabtest()">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                  </n-button>
                  <n-button v-show="selectedLabTest.newTest" type="primary" social icon round @click.native="addNewLabTest(selectedLabTest)">
                    <i class="fa fa-save"></i>
                  </n-button>
                </div>
                <div class="col-12 col-md-12 mt-3">
                  <fg-input style="margin-top: 2em;" type="text" label="Test Name" v-model="selectedLabTest.name"></fg-input>
                </div>
                <div class="col-12 col-md-12">
                  <fg-input type="text" v-model="selectedLabTest.comment" :label="$t('message.Comment :')"></fg-input>
                </div>
              </div>
            </card>
          </div>
        </div>

        <template slot="footer">
          <div v-if="selectedLabTest" class="text-center" style="width: 100%;">
            <n-button type="primary" round @click.native="addLabTestToPrescription(selectedLabTest)">
              <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
            </n-button>
          </div>
        </template>
      </modal>

      <!-- Imaging selction modal-->
      <modal :show.sync="SHOW_IMAGING_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onImagingSelectionModalClosed()">
        <h6 slot="header" class="title title-up">{{ $t("message.Select Imaging") }}</h6>
        <div class="row" v-if="!selectedImaging">
          <div class="col-12 pl-5 pr-5">
            <el-select class="select-primary" size="large" label="Imaging Prescriptions" placeholder="Select Imaging type" style="margin-top: -0.5em;">
              <el-option v-for="imagingType in imagingTypesList" :key="imagingType" @click.native="addImagingType(imagingType)" class="select-primary" :value="imagingType" :label="imagingType"></el-option>
            </el-select>
          </div>
        </div>

        <div class="row pl-3 pr-3" v-if="selectedImaging">
          <div class="col-12">
            <card v-for="imagingType in selectedImagingFromList" :key="imagingType.name">
              <div class="row">
                <div class="col-6">
                  <h6>{{ imagingType.name }}</h6>
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <n-button type="danger" social icon round @click.native="selectedImaging = null" style="margin-top: 0em;">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                  </n-button>
                </div>
              </div>
              <div class="row">
                <div v-for="(option, index) in imagingType.options" :key="index" :class="option.type == 'check' ? 'col-6' : 'col-12'">
                  <div v-if="option.type == 'check' && option.label">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" @click="selectOption(imagingType.name, option, null)" class="form-check-input">
                        <span class="form-check-sign"></span> {{ option.label }}</label>
                    </div>
                  </div>
                  <div v-if="option.type == 'check-text' && option.label">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" @click="selectOption(imagingType.name, option, specification[imagingType.name][index])" class="form-check-input">
                        <span class="form-check-sign"></span> {{ option.label }}</label>
                    </div>
                    <input aria-describedby="addon-right addon-left" v-model="specification[imagingType.name][index]" type="text" @blur="updateSpecification(imagingType.name, option, specification[imagingType.name][index])" @focus="resetSpecification(imagingType.name, option, specification[imagingType.name][index])" :placeholder="option.label" class="form-control valid" style="margin-top: 0.5em;">
                  </div>
                  <div v-if="option.type == 'text' && option.label">
                    <label>{{ option.label }}</label>
                    <div class="form-group input-group-focus has-success">
                      <input aria-describedby="addon-right addon-left" type="text" @blur="updateText(imagingType.name, option, $event.target.value)" @focus="resetText(imagingType.name, option, $event.target.value)" :placeholder="option.label" class="form-control valid">
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="imagingType.name == 'Breast Imaging'" class="row">
                <br />
                <div class="col-12 d-flex justify-content-end">
                  <i class="fas fa-sync" @click="refreshBreastImaging()"></i>
                </div>
                <div class="col-12">
                  <vue-signature ref="breastImage" @touchend.native="updateBreastImage()" :sigOption="signaturePadOptions" :w="'100%'" :h="'20em'" :defaultUrl="require('../../../assets/img/breast-image.jpg')"></vue-signature>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-12">
                  <input aria-describedby="addon-right addon-left" type="text" @keyup="updateComment(imagingType.name, $event.target.value)" placeholder="comment" class="form-control valid">
                </div>
              </div>
            </card>
          </div>
        </div>

        <template slot="footer">
          <div v-if="selectedImaging" class="text-center" style="width: 100%;">
            <n-button type="primary" round @click.native="addImagingToPrescription(selectedImaging)">
              <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
            </n-button>
          </div>
        </template>
      </modal>
    </div>

    <!-- Uneditable -->
    <div v-if="!editable">
      <div class="text-center" v-if="!hasPrescription(prescription)">
        <div class="row">
          <div class="col-12 mt-5">{{ $t("message.Nothing prescribed during the appointment") }}</div>
          <div class="col-12 mt-5">
            <not-found-svg style="width: 100%; height: auto;"></not-found-svg>
          </div>
        </div>
      </div>

      <div class="col-12 pb-1 mb-4 text-center" style="border-bottom: 1px solid #00000045" v-if="hasPrescription(prescription) && provider">
        <i class="fa fa-user-md"></i>
        &nbsp;
        {{ $t("message.Dr") }}. {{ provider.firstName }}
        {{ provider.lastName }},
        <span v-if="provider.description">{{ provider.description }} -</span>
        {{ provider.specialityText }}
        <br />
        <span v-if="provider.registration.number">{{ provider.registration.number }} -</span>
        {{ provider.registration.city }}
      </div>

      <!-- Descriptive Notes -->
      <div class="row" v-if="prescription.descriptiveNotes">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Descriptive Notes") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>{{ prescription.descriptiveNotes }}</card>
        </div>
      </div>

      <!-- Chief Complaints -->
      <div class="row" v-if="prescription.chiefComplaints">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Chief Complaints") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>{{ prescription.chiefComplaints }}</card>
        </div>
      </div>

      <!-- Relevant Points from History -->
      <div class="row" v-if="prescription.relevantPointsfromHistory">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Relevant Points from History") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>{{ prescription.relevantPointsfromHistory }}</card>
        </div>
      </div>

      <!-- Examination/Lab Findings -->
      <div class="row" v-if="prescription.labFindings">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Examination/Lab Findings") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>{{ prescription.labFindings }}</card>
        </div>
      </div>

      <!-- Provisional Diagnosis -->
      <div class="row" v-if="prescription.provisionalDiagnosis.notes ||
        prescription.provisionalDiagnosis.icdCodes.length > 0
        ">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Diagnosis or Provisional Diagnosis") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <div class="row">
            <div class="col-12 col-md-12" v-if="prescription.provisionalDiagnosis.notes">
              <span style="font-size: large">{{
                $t("message.Provisonal Notes")
              }}</span>
            </div>
            <div class="col-12 col-md-12" v-if="prescription.provisionalDiagnosis.notes">
              <card>{{ prescription.provisionalDiagnosis.notes }}</card>
            </div>
            <div class="col-12 col-md-12" v-if="prescription.provisionalDiagnosis.icdCodes.length > 0">
              <span style="font-size: large">{{
                $t("message.ICD Codes")
              }}</span>
            </div>
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-12 col-md-12">
                  <card v-for="icdCode in prescription.provisionalDiagnosis
                    .icdCodes" :key="icdCode.Code">
                    <div class="col-12 col-md-12">
                      <label class="label-style">{{
                        $t("message.Code")
                      }}</label>
                    </div>
                    <div class="col-12 col-md-12">
                      <div>{{ icdCode.Code }}</div>
                    </div>
                    <div class="col-12 col-md-12">
                      <label class="label-style">{{
                        $t("message.Description")
                      }}</label>
                    </div>
                    <div class="col-12 col-md-12">
                      <div>{{ icdCode.Description }}</div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rx Prescription -->
      <div class="row" v-if="prescription.rx.length > 0">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.RX Prescription") }}</h6>
          <card v-for="drug in prescription.rx" :key="drug.xyz">
            <p> {{ drug.name }} </p>
            <div>{{ drug.routeOfAdministration }}</div>
            <div>{{ drug.instruction }}</div>
            <div> {{ drug.frequency ? ((drug.frequency.durationNo || drug.frequency.duration == 'Till Next Visit') ? ((drug.frequency.duration != 'Till Next Visit' && drug.frequency.duration) ? 'For ' + (drug.frequency.durationNo ? drug.frequency.durationNo + " - " + drug.frequency.duration + " " : "") : drug.frequency.duration) : "") + (drug.frequency.day ? " " + drug.frequency.day : "") : "" }} </div>
            <div style="display: flex; justify-content: space-between;">
              <div> {{ drug.frequency && drug.frequency.when ? ((drug.frequency.minutes ? drug.frequency.minutes + " Mins " : "") + (drug.frequency.when ? "- " + drug.frequency.when : "")) : "" }} </div>
              <div style="display: flex;">
                <div style="margin: 2px; text-align: center;">
                  <div>
                    M
                  </div>
                  <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                    {{ drug.frequency ? (drug.frequency.morning ? (drug.frequency.morning.nos ? drug.frequency.morning.nos.toString() : "0") : "0") : " " }}
                  </div>
                </div>
                <div style="margin: 2px; text-align: center;">
                  <div>
                    A
                  </div>
                  <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                    {{ drug.frequency ? (drug.frequency.afternoon ? (drug.frequency.afternoon.nos ? drug.frequency.afternoon.nos.toString() : "0") : "0") : " " }}
                  </div>
                </div>
                <div style="margin: 2px; text-align: center;">
                  <div>
                    E
                  </div>
                  <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                    {{ drug.frequency ? (drug.frequency.evening ? (drug.frequency.evening.nos ? drug.frequency.evening.nos.toString() : "0") : "0") : " " }}
                  </div>
                </div>
                <div style="margin: 2px; text-align: center;">
                  <div>
                    N
                  </div>
                  <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                    {{ drug.frequency ? (drug.frequency.night ? (drug.frequency.night.nos ? drug.frequency.night.nos.toString() : "0") : "0") : " " }}
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- Lab Prescriptions -->
      <div class="row" v-if="prescription.labPrescription.length > 0">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Lab Prescription") }}</h6>
          <card id="labCardOpen" v-for="labTest in prescription.labPrescription" :key="labTest.xyz">
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-12 col-md-12">
                  <label class="label-style">{{
                    $t("message.Test")
                  }}</label>
                </div>
                <div class="col-12 col-md-12">
                  <div>{{ labTest.test }}</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12" v-if="labTest.comment">
              <div class="row">
                <div class="col-12 col-md-12">
                  <label class="label-style">{{
                    $t("message.Comment :")
                  }}</label>
                </div>
                <div class="col-12 col-md-12">
                  <div>{{ labTest.comment }}</div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- Imaging Prescription -->
      <div class="row" v-if="prescription.imagingPrescription &&
        prescription.imagingPrescription.types.length > 0
        ">
        <div class="col-12">
          <h6>{{ $t("message.Imaging Prescription") }}</h6>
        </div>
        <div class="col-12">
          <card v-for="imagingType in prescription.imagingPrescription.types" class="card-nav-tabs" header-classes="card-header-warning" :key="imagingType.type">
            <div slot="header">{{ imagingType.type }}</div>
            <div>
              <dynamic-image v-if="imagingType.imageData" :file-id="imagingType.imageData">
              </dynamic-image>
            </div>
            <div class="row" style="font-size: x-small">
              <div class="col-12" v-for="option in imagingType.option" :key="option">
                <i class="fa fa-check-square"></i>
                {{ option }}
              </div>

              <span v-if="imagingType.comment" class="col-12">
                <span>{{ $t("message.Comment :") }}</span>
                {{ imagingType.comment }}
              </span>
            </div>
          </card>
        </div>
      </div>

      <!-- Diet Plan -->
      <div class="row" v-if="hasDietPlan(prescription)">
        <div class="col-12">
          <h6>{{ $t("message.Diet Plan") }}</h6>
        </div>

        <!-- Daily Plan -->
        <div class="col-12 p-0" v-if="prescription.dietPlan.type == 'daily'">
          <daily-diet-plan :daily-plan="prescription.dietPlan.dailyPlan"></daily-diet-plan>
        </div>

        <!-- Weekly Plan -->
        <div v-if="prescription.dietPlan.type == 'weekly'">
          <collapse :multiple-active="false" :active-index="0">
            <collapse-item :title="day | capitalCase" v-for="(plan, day) in prescription.dietPlan.weeklyPlan" :key="day">
              <div class="col-12 p-0">
                <daily-diet-plan :daily-plan="plan"></daily-diet-plan>
              </div>
            </collapse-item>
          </collapse>
        </div>

        <br />

        <!-- Notes -->
        <div class="col-12 mt-2" v-if="prescription.dietPlan.notes">
          <span style="font-size: large">{{
            $t("message.Day(s)")
          }}</span>
          <span class="pl-2">{{ prescription.dietPlan.notes }}</span>
        </div>

        <!-- Tips -->
        <div class="col-12 mt-2" v-if="prescription.dietPlan.tips.length > 0">
          <span style="font-size: large">{{
            $t("message.Week(s)")
          }}</span>
          <div class="col-12" v-for="(tip, index) in prescription.dietPlan.tips">
            {{ index + 1 }}. {{ tip }}
          </div>
        </div>
      </div>

      <!-- Attchments -->
      <div class="row" v-if="prescription.attachments && prescription.attachments.length > 0">
        <div class="col-12">
          <h6>{{ $t("message.Attachments") }}</h6>
        </div>

        <div class="col-12" v-for="attachment in prescription.attachments">
          <card @click.native="viewFile(attachment)">
            <div class="row">
              <!-- Thumbnail -->
              <div class="col-2 pr-0">
                <dynamic-image v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId">
                </dynamic-image>
                <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i>
              </div>
              <div class="col-10" style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  margin: auto;
                ">
                {{ attachment.name }}
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- Follow Up -->
      <div class="row" v-if="prescription.followup && prescription.followup.requested">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Follow up") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>
            <div v-if="prescription.followup.followupDate">
              <span>{{ $t("message.On") }}</span>
              {{ getFormattedDate(prescription.followup.followupDate) }}
            </div>
            <div v-else>
              <span>{{ $t("message.After") }}</span>
              {{ prescription.followup.durationNo }} {{ prescription.followup.duration }}
            </div>
            <div v-if="prescription.followup.comments">
              <label class="label-style">{{ $t("message.Comments") }}</label>
              <p>{{ prescription.followup.comments }}</p>
            </div>
          </card>
        </div>
      </div>

      <!-- Emergency Care -->
      <div class="row" v-if="prescription.emergencyCare">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Emergency Care") }}</h6>
        </div>
        <div class="col-12 col-md-12">
          <card>{{ prescription.emergencyCare }}</card>
        </div>
      </div>

      <!-- Recommendations -->
      <div class="col-12" v-if="prescription.recommendations">
        <h6>{{ $t("message.Recommendations:") }}</h6>
        <card>
          <div v-for="(recommendation, index) in prescription.recommendations" :key="index">
            <div>{{ recommendation }}</div>
          </div>
        </card>
      </div>

      <!-- Referrals -->
      <div v-if="prescription.referrals">
        <div class="col-12">
          <h6>{{ $t("message.Referrals") }}</h6>
        </div>
        <card>
          <div v-if="prescription.referrals.provider.fullName">
            <div>
              <label class="label-style">{{ $t("message.Referred To:") }}</label>
            </div>
            <div style="padding-left: 1em;">
              <span>Dr.{{ prescription.referrals.provider.fullName }},</span>
              <span v-if="prescription.referrals.provider.specialityText">{{ prescription.referrals.provider.specialityText }}</span>
            </div>
          </div>
          <div v-if="prescription.referrals.hospital.name">
            <div>
              <label class="label-style">{{ $t("message.Hospital Name:") }}</label>
            </div>
            <span style="padding-left: 1em;">{{ prescription.referrals.hospital.name + ', ' + prescription.referrals.hospital.address }}</span>
          </div>
          <div v-if="prescription.referrals.comments">
            <div>
              <label class="label-style">{{ $t("message.Comments:") }}</label>
            </div>
            <span style="padding-left: 1em;">{{ prescription.referrals.comments }}</span>
          </div>

        </card>
      </div>

      <!-- SpecialInstructions -->
      <div class="row" v-if="prescription.specialInstructions">
        <div class="col-12">
          <h6>{{ $t("message.SpecialInstructions:") }}</h6>
          <div>{{ prescription.specialInstructions }}</div>
        </div>
      </div>

      <!-- Other comments -->
      <div class="row" v-if="prescription.otherComments">
        <div class="col-12">
          <h6>{{ $t("message.Other Comments") }}</h6>
          <div>{{ prescription.otherComments }}</div>
        </div>
      </div>
    </div>

    <!-- camera component -->
    <app-camera :showCam="SHOW_CAPTURE_MODAL" ref="camera" @closeCamera="closeCaptureModal" @imageCaptured="saveImage">
    </app-camera>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import "sweetalert2/dist/sweetalert2.css";
var icdCodes = require("@/assets/json/icd10.min.json");
var labTests = require("@/assets/json/lab-tests.json");
import FileService from "../../../services/file.service";
import AppCamera from "./AppCamera.vue";

import NotFoundSvg from "../components/svg_images/NotFoundSvg.vue";
import DailyDietPlan from "src/pages/carenation/components/DailyDietPlan.vue";
import PrescriptionService from "../../../services/prescription.js";

export default {
  name: "prescription",

  data() {
    return {
      SHOW_CAPTURE_MODAL: false,
      ICD_CODE_NOT_FOUND: false,
      DRUG_NOT_FOUND: false,
      LAB_TEST_NOT_FOUND: false,
      icdCodesList: [],
      selectedDrug: [],
      selectedLabTest: null,
      drugList: [],
      labTestList: [],
      selectIcdCodes: [],
      frequentDrugs: [],
      selectedIcd: null,
      newTest: false,
      morningFrequency: "",
      prescriptionListener: null,
      imagingTypesList: [
        "MRI",
        "CT",
        "Radiology (X-ray)",
        "Fluoroscopy",
        "Ultrasound",
        "Nuclear Medicine",
        "Breast Imaging",
        "DEXA",
      ],
      imagingList: [
        {
          name: "MRI",
          options: [
            {
              label: "With IV contrast",
              type: "check",
            },
            { label: "Brain MRA", type: "check" },
            { label: "Brain MRI", type: "check" },
            { label: "Knee (R)", type: "check" },
            {
              label: "Without contrast",
              type: "check",
            },
            { label: "Knee (L)", type: "check" },
            {
              label: "Thoracic spine",
              type: "check",
            },
            { label: "Lumbar spine", type: "check" },
            {
              label: "With and without IV contrast",
              type: "check",
            },
            {
              label: "Cervical spine",
              type: "check",
            },
            { label: "Shoulder (R)", type: "check" },
            { label: "", type: "" },
            { label: "Shoulder (L)", type: "check" },
            {
              label: "Checkbox if claustrophobic",
              type: "check",
            },
            {
              label: "Conscious sedation/ anesthesia requested",
              type: "check",
            },
            {
              label: "Extremity other",
              type: "check-text",
              specification: "",
            },
            { label: "", type: "" },
            { label: "", type: "" },
            { label: "Creatinine", type: "text" },
            { label: "GFR", type: "text" },
          ],
        },
        {
          name: "CT",
          options: [
            {
              label: "With IV contrast",
              type: "check",
            },
            {
              label: "Sinus",
              type: "check",
            },
            {
              label: "Renal colic",
              type: "check",
            },
            {
              label: "Head CT",
              type: "check",
            },
            {
              label: "Without contrast",
              type: "check",
            },
            {
              label: "Abdomen and Pelvis",
              type: "check",
            },
            {
              label: "Abdomen",
              type: "check",
            },
            {
              label: "Pelvis",
              type: "check",
            },
            {
              label: "With and without IV contrast",
              type: "check",
            },
            {
              label: "Urogram",
              type: "check",
            },
            {
              label: "Cardiac",
              type: "check",
            },
            {
              label: "With calcium score",
              type: "check",
            },
            {
              label: "",
              type: "",
            },
            {
              label: "Spine (Cervical)",
              type: "check",
            },
            {
              label: "Spine (Thoracic)",
              type: "check",
            },
            {
              label: "Spine (Lumbar)",
              type: "check",
            },
            {
              label: "",
              type: "",
            },
            {
              label: "CTA",
              type: "check-text",
            },
            {
              label: "Extremity",
              type: "check-text",
            },
            {
              label: "Creatinine",
              type: "text",
            },
            {
              label: "",
              type: "",
            },
            {
              label: "GFR",
              type: "text",
            },
          ],
        },
        {
          name: "Radiology (X-ray)",
          options: [
            {
              label: "Chest (PA/lateral)",
              type: "check",
            },
            {
              label: "Chest (1 view)",
              type: "check",
            },
            {
              label: "KUB",
              type: "check",
            },
            {
              label: "C spine",
              type: "check",
            },
            {
              label: "Thoracic spine",
              type: "check",
            },
            {
              label: "Acute abdomen (2 view abd + 1 view cxr)",
              type: "check",
            },
            {
              label: "Lumbar spine additional views",
              type: "check-text",
            },
            {
              label: " Extremity/joint (R/L)",
              type: "check-text",
            },
          ],
        },
        {
          name: "Fluoroscopy",
          options: [
            {
              label: "Esophagram",
              type: "check",
            },
            {
              label: "Upper GI",
              type: "check",
            },
            {
              label: "Small bowel follow-through",
              type: "check",
            },
            {
              label: "Video swallowing study",
              type: "check",
            },
            {
              label: "Barium enema",
              type: "check",
            },
            {
              label: "Barium enema (with air)",
              type: "check",
            },
            {
              label: "VCUG",
              type: "check",
            },
            {
              label: "Myelogram (Cervical)",
              type: "check",
            },
            {
              label: "Myelogram (Thoracic)",
              type: "check",
            },
            {
              label: "Myelogram (Lumbar)",
              type: "check",
            },
            {
              label: "Lumbar puncture",
              type: "check-text",
            },
            {
              label: "Arthrogram",
              type: "check-text",
            },
            {},
            {},
            {
              label: "Joint injection",
              type: "check-text",
            },
          ],
        },
        {
          name: "Ultrasound",
          options: [
            {
              label: "Complete abdomen",
              type: "check",
            },
            {
              label: "Limited abdomen",
              type: "check-text",
            },
            {},
            {},
            {
              label: "Pelvis",
              type: "check",
            },
            {
              label: "OB",
              type: "check",
            },
            {
              label: "Renal",
              type: "check",
            },
            {
              label: "Scrotum",
              type: "check",
            },
            {
              label: "Thyroid",
              type: "check",
            },
            {
              label: "Thyroid FNA",
              type: "check",
            },
            {},
            {},
            {
              label: "Carotid",
              type: "check",
            },
            {
              label: "AAA",
              type: "check",
            },
            {
              label: "Venous (DVT)",
              type: "check",
            },
            {
              label: "Lower extremity (R)",
              type: "check",
            },
            {
              label: "Lower extremity (L)",
              type: "check",
            },
            {
              label: "Lower extremity (Bilateral)",
              type: "check",
            },
            {},
            {
              label: "Upper extremity (R)",
              type: "check",
            },
            {
              label: "Upper extremity (L)",
              type: "check",
            },
            {
              label: "Upper extremity (Bilateral)",
              type: "check",
            },
            {
              label: "Arterial",
              type: "check",
            },
            {
              label: "US PVS",
              type: "check",
            },
            {
              label: "ABI only",
              type: "check",
            },
            {
              label: "Full peripheral",
              type: "check",
            },
            {
              label:
                "Kidneys, Uterus and Bladder (KUB) with Post-Void Residual (PVR)",
              type: "check",
            },
          ],
        },
        {
          name: "Nuclear Medicine",
          options: [
            {
              label: "Whole body bone scan *with SPECT",
              type: "check-text",
            },
            {
              label: "3 phase bone scan *with SPECT",
              type: "check-text",
            },
            {
              label: "Multiple areas bone scan *with SPECT",
              type: "check-text",
            },
            {
              label: "PET/CT",
              type: "check-text",
            },
            {},
            {
              label: "Thyroid uptake + scan",
              type: "check",
            },
            {
              label: "MUGA",
              type: "check",
            },
            {
              label: "Gastric emptying (solid)",
              type: "check",
            },
            {
              label: "Gastric emptying (liquid)",
              type: "check",
            },
            {
              label: "Gastric emptying (solid-liquid)",
              type: "check",
            },
            {
              label: "HIDA",
              type: "check",
            },
            {
              label: "HIDA (with ejection fraction)",
              type: "check",
            },
            {
              label: "Renal scan (Lasix)",
              type: "check",
            },
            {
              label: "Renal scan (MAG3)",
              type: "check",
            },
            {
              label: "Renal scan (DPTA)",
              type: "check",
            },
            {
              label: "Myocardial perfusion (Treadmill)",
              type: "check",
            },
            {
              label: "Myocardial perfusion (Pharmacological)",
              type: "check",
            },
          ],
        },
        {
          name: "Breast Imaging",
          options: [
            {
              label: "Screening mammogram",
              type: "check",
            },
            {
              label: "Breast ultrasound only",
              type: "check",
            },
            {
              label: "Diagnostic mammogram",
              type: "check",
            },
            {
              label: "Breast MRI",
              type: "check",
            },
            {
              label: "Breast ultrasound and biopsy if indicated",
              type: "check",
            },
          ],
        },
        {
          name: "DEXA",
          options: [
            {
              label: "Hip/lumbar",
              type: "check",
            },
            {
              label: "Forearm/ankle",
              type: "check",
            },
          ],
        },
      ],
      signaturePadOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      specification: {},
      icdCodesSearchText: "",
      drugsSearchText: "",
      labTestsSearchText: "",
      provider: null,
      routesOfAdministration: [
        "Oral",
        "Sublingual",
        "Buccal",
        "Inhalation",
        "Nasal",
        "Transdermal",
        "Subcutaneous",
        "Intramuscular",
        "Intravenous",
        "Intradermal",
        "Topical-Skin",
        "Topical-Otic",
        "Topical-Urethral",
        "Topical-Vaginal",
        "Topical-Anal",
        "Rectal",
        "Ophthalmic-Topical",
        "Ophthalmic-Retrobulbar",
        "Ophthalmic-Intracameral",
        "Ophthalmic-Intravitreal",
        "Intraarticular",
        "Intrathecal",
        "Intraarterial",
      ],
      SHOW_RX_SELECTION_MODAL: false,
      SHOW_ICD_SELECTION_MODAL: false,
      SHOW_LABTEST_SELECTION_MODAL: false,
      SHOW_IMAGING_SELECTION_MODAL: false,
      selectedRX: null,
      selectedImaging: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    appointment() {
      return this.$store.state.appointment;
    },
    imaging() {
      let that = this;

      let selectedList = this.imagingList.filter((type) => {
        for (let value of that.prescription.imagingPrescription.types) {
          if (value.type == type.name) {
            return true;
          }
        }
        return false;
      });

      return selectedList;
    },
    selectedImagingFromList() {
      return this.imagingList.filter((type) => {
        return this.selectedImaging.type == type.name;
      });
    },
  },

  props: {
    appCamera: {
      type: Boolean,
    },
    prescription: {
      type: Object,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    CoolSelect,
    AppCamera,
    NotFoundSvg,
    "daily-diet-plan": DailyDietPlan,
  },

  methods: {
    //Files
    async browseFiles() {
      let file = await chooser.getFile();

      if (file) {
        this.uploadFile(file);
      }
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    addImagingType(imagingType) {
      this.selectedImaging = { type: imagingType };
    },
    removeImagingType(imagingType, typeName) {
      let that = this;
      this.prescription.imagingPrescription.types.forEach(function (
        imaging,
        index
      ) {
        if (imaging.type == imagingType) {
          that.prescription.imagingPrescription.types.splice(index, 1);
        }
      });
      this.specification[typeName] = [];
    },
    selectOption(type, option, specification) {
      if (this.selectedImaging.option == undefined) {
        this.selectedImaging.option = [];
      }
      if (this.selectedImaging.type == type) {
        if (this.selectedImaging.option.indexOf(option.label) > -1) {
          this.selectedImaging.option.splice(
            this.selectedImaging.option.indexOf(option.label),
            1
          );
        } else if (
          specification &&
          this.selectedImaging.option.indexOf(
            option.label + ": " + specification
          ) > -1
        ) {
          this.selectedImaging.option.splice(
            this.selectedImaging.option.indexOf(
              option.label + ": " + specification
            ),
            1
          );
        } else if (specification) {
          this.selectedImaging.option.push(option.label + ": " + specification);
        } else {
          this.selectedImaging.option.push(option.label);
        }
      }
    },
    resetSpecification(type, option, specification) {
      if (this.selectedImaging.type == type) {
        if (specification) {
          this.selectedImaging.option[
            this.selectedImaging.option.indexOf(
              option.label + ": " + specification
            )
          ] = option.label;
        }
      }
    },
    updateSpecification(type, option, specification) {
      if (this.selectedImaging.type == type && specification) {
        this.selectedImaging.option[
          this.selectedImaging.option.indexOf(option.label)
        ] = this.selectedImaging.option[
          this.selectedImaging.option.indexOf(option.label)
        ].concat(": " + specification);
      }
    },

    resetText(type, option, text) {
      if (this.selectedImaging.type == type && text) {
        console.log(
          this.selectedImaging.option.indexOf(option.label + ": " + text)
        );
        this.selectedImaging.option.splice(
          this.selectedImaging.option.indexOf(option.label + ": " + text),
          1
        );
      }
    },

    updateText(type, option, text) {
      if (this.selectedImaging.type == type && text) {
        if (this.selectedImaging.option == undefined) {
          this.selectedImaging.option = [];
        }
        this.selectedImaging.option.push(option.label + ": " + text);
      }
    },

    updateComment(type, comment) {
      if (this.selectedImaging.type == type) {
        this.selectedImaging.comment = comment;
      }
    },
    refreshBreastImaging() {
      this.$refs.breastImage[0].fromDataURL(
        require("@/assets/img/breast-image.jpg")
      );
    },
    async updateBreastImage() {
      if (this.selectedImaging.type == "Breast Imaging") {
        if (this.selectedImaging.imageData == undefined) {
          this.selectedImaging.imageData = "";
        }
        let fileId = await FileService.uploadDataUrl(
          this.$refs.breastImage[0].save()
        );
        if (fileId) {
          this.selectedImaging.imageData = fileId;
        } else {
          this.selectedImaging.imageData = "";
        }
      }
    },
    closeCaptureModal() {
      this.$emit("attachementCaptured");
    },
    async saveImage(fileData) {
      let _this = this;

      const { value: fileName } = await swal.fire({
        title: _this.$t("message.Enter file name"),
        input: "text",
        inputValue: "Attachment.png",
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && _this.$t("message.Please Enter filename!");
        },
      });
      if (fileName) {
        let fileBlob = _this.dataURItoBlob(fileData);
        let fileToSave = {
          name: fileName.endsWith(".png") ? fileName : fileName + ".png",
          data: fileBlob,
          type: "image/png",
          size: fileBlob.size,
        };
        _this.saveFile(fileToSave);
      }
    },

    initiateOpenCamera() {
      if (this.appCamera) {
        this.$emit("openCameraModal");
      } else {
        this.openCameraForFileUpload();
      }
    },
    openCameraModalForFileUpload() {
      setTimeout(() => {
        this.SHOW_CAPTURE_MODAL = true;
        this.$refs.camera.createCameraElement();
      }, 1000);
    },
    async openCameraForFileUpload() {
      var _this = this;
      navigator.camera.getPicture(
        async function (base64Data) {
          var fileData = "data:image/png;base64," + base64Data;
          const { value: fileName } = await swal.fire({
            title: _this.$t("message.Enter file name"),
            input: "text",
            inputValue: "Attachment.png",
            showCancelButton: true,
            inputValidator: (value) => {
              return !value && _this.$t("message.Please Enter filename!");
            },
          });
          if (fileName) {
            let fileBlob = _this.dataURItoBlob(fileData);
            let fileToSave = {
              name: fileName.endsWith(".png") ? fileName : fileName + ".png",
              data: fileBlob,
              type: "image/png",
              size: fileBlob.size,
            };
            _this.saveFile(fileToSave);
          }
        },
        function (err) {
          console.log("error opening camera");
        },
        {
          sourceType: Camera.PictureSourceType.CAMERA,
          destinationType: Camera.DestinationType.DATA_URL,
          mediaType: Camera.MediaType.PICTURE,
          // allowEdit: true,
          correctOrientation: false,
          encodingType: Camera.EncodingType.PNG,
          quality: 10,
          cameraDirection: Camera.Direction.BACK,
          targetWidth: 300,
          targetHeight: 400,
        }
      );
    },
    async uploadFile(file) {
      let that = this;
      let loader = that.$loading.show({
        container: null,
        canCancel: false,
      });

      try {
        let response = await that.$store.dispatch("uploadFileToMinio", file);

        var fileDetails = {
          name: file.name,
          type: file.mediaType,
          size: response.fileSize,
          fileId: response.fileId,
        };

        fileDetails.appointmentId = this.appointment._id;
        fileDetails.patientId = this.appointment.patient.patientId;

        //Save file details in mongo
        try {
          let savedFile = await this.$store.dispatch(
            "savePatientFile",
            fileDetails
          );
          if (!this.prescription.attachments) {
            this.prescription.attachments = [];
          }
          this.prescription.attachments.push(savedFile);
          loader.hide();
          this.$forceUpdate();
          swal.fire({
            title: this.$t("message.File Attached!"),
            type: "success",
            timer: 2000,
          });
          socket.emit("filesUpdate", {
            appointmentId: this.appointment._id,
            userId: this.user._id,
          });
        } catch (e) {
          loader.hide();
          console.log("Error updating file share status", e);
          swal.fire({
            title: this.$t("message.File couldn't be shared!"),
            type: "error",
            timer: 5000,
          });
        }
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "error",
          title: this.$t("message.File upload error"),
          text: this.$t("message.Could not update the file"),
          timer: 5000,
        });
      }
    },
    async saveFile(file) {
      //if file size is> 10MB, reject
      //1000000
      let _this = this;
      if (file.size / 1000000 > 10) {
        swal.fire({
          title: _this.$t("message.Ooops!"),
          text: _this.$t("message.Maximum file size allowed is 10MB!"),
          type: "error",
          timer: 5000,
        });
      } else {
        file.appointmentId = this.appointment._id;
        file.patientId = this.appointment.patient.patientId;
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          let _file = await _this.$store.dispatch("uploadFile", file);
          if (!this.prescription.attachments) {
            this.prescription.attachments = [];
          }
          this.prescription.attachments.push(_file);
          loader.hide();
          this.$forceUpdate();
          swal.fire({
            title: this.$t("message.File Shared!"),
            type: "success",
            timer: 3000,
          });

          socket.emit("filesUpdate", {
            appointmentId: this.appointment._id,
            userId: this.user._id,
          });
        } catch (err) {
          loader.hide();
          swal.fire({
            title: _this.$t("message.Ooops!"),
            text: _this.$t("message.Error while uploading file!"),
            type: "error",
            timer: 5000,
          });
        }
      }
    },
    async deleteFile(file, index) {
      let _this = this;
      swal
        .fire({
          title: _this.$t("message.Delete File?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: _this.$t("message.Yes"),
          cancelButtonText: _this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            _this.loader = _this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            try {
              await _this.$store.dispatch("deleteFile", file);
              this.prescription.attachments.splice(index, 1);
              _this.loader.hide();
              this.$forceUpdate();
              swal
                .fire({
                  title: _this.$t("message.Success!"),
                  text: _this.$t("message.File deleted successfully"),
                  type: "success",
                  timer: 3000,
                })
                .then(() => {
                  console.log("files :", this.prescription.attachments);
                });
            } catch (err) {
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Ooops!"),
                text: _this.$t("message.Error while deleting file"),
                type: "error",
                timer: 5000,
              });
            }
          } else {
            swal.close();
          }
        });
    },
    async viewFile(file) {
      let that = this;
      try {
        that.loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch(
          "getFile",
          file.fileId
        );

        let pdfBlob = new Blob([fileArrayBuffer]);

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              storageLocation = cordova.file.externalDataDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                file.name,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            that.loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            that.loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        that.loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      that.loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              that.loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        that.loader.hide();
        console.log(e);
      }
    },

    getShortDosageName(dosageName) {
      if (dosageName) {
        var dosName = "";
        var dName = dosageName.split(",");

        dName.forEach((value, index) => {
          value = value.trim();
          if (index == 0) {
            dosName = dosName + value.substr(0, 3);
          } else {
            dosName = dosName + ", " + value.substr(0, 3);
          }
        });
        return dosName;
      }
    },
    hasPrescription(prescription) {
      return PrescriptionService.hasPrescription(prescription);
    },
    hasDietPlan(prescription) {
      return PrescriptionService.hasDietPlan(prescription);
    },
    selectIcdCode(icd) {
      this.selectedIcd = icd;
    },
    selectDrugs(drug) {
      drug.frequency = {
        duration: "Days",
      };

      this.selectedRX = {
        _id: drug._id,
        dosageForm: drug.dosageFormName.toLowerCase(),
        name: drug.substanceName + " " + drug.activeNumeratorStrength,
        frequency: {
          morning: {
            nos: "",
          },
          afternoon: {
            nos: "",
          },
          evening: {
            nos: "",
          },
          night: {
            nos: "",
          },
        },
      };
    },
    addDrugToPrescription(drug) {
      if (!this.prescription.rx) {
        this.prescription.rx = [];
      }
      this.prescription.rx.push(drug);
      this.drugList = this.frequentDrugs;
      this.drugsSearchText = null;
      this.onRxSelectionModalClosed();
    },
    addIcdToPrescription(icd) {
      this.prescription.provisionalDiagnosis.icdCodes.push(icd);
      this.icdCodesList = [];
      this.icdCodesSearchText = null;
      this.onIcdSelectionModalClosed();
    },
    addLabTestToPrescription(labTest) {
      if (!this.prescription.labPrescription) {
        this.prescription.labPrescription = [];
      }
      this.prescription.labPrescription.push({
        _id: labTest._id,
        test: labTest.name,
        comment: labTest.comment,
        endpoints: labTest.endpoints,
      });
      this.labTestList = [];
      this.labTestsSearchText = null;
      this.onLabTestSelectionModalClosed();
    },
    addImagingToPrescription(imagingType) {
      if (this.prescription.imagingPrescription.types.length == 0) {
        this.prescription.imagingPrescription.types.push(imagingType);
      } else {
        let isPresent = false;
        this.prescription.imagingPrescription.types.forEach((object) => {
          if (object.type == imagingType.type) {
            isPresent = true;
          }
        });

        if (!isPresent) {
          this.prescription.imagingPrescription.types.push(imagingType);
        }
      }
      this.onImagingSelectionModalClosed();
    },
    selectLabTests(labTest) {
      this.selectedLabTest = Object.assign(labTest, { comment: "" });
    },
    searchIcdCodes(searchfor) {
      if (searchfor) {
        var query = searchfor.toLowerCase();
        this.icdCodesList = icdCodes.filter(function (icdCode) {
          if (icdCode.Code) {
            return (
              icdCode.Code.toLowerCase().indexOf(query) === 0 ||
              icdCode.Description.toLowerCase().indexOf(query) === 0
            );
          }
        });
      } else {
        this.icdCodesList = [];
      }

      if (searchfor.length > 0) {
        this.ICD_CODE_NOT_FOUND = this.icdCodesList.length == 0;
      }
    },
    async searchDrugs(searchfor) {
      if (searchfor) {
        this.drugList = await this.$store.dispatch("searchDrugs", searchfor);
      } else {
        this.drugList = this.frequentDrugs;
      }

      if (searchfor.length > 0) {
        this.DRUG_NOT_FOUND = this.drugList.length == 0;
      }
    },
    async searchLabTests() {
      if (this.labTestsSearchText.length > 0) {
        try {
          this.labTestList = await this.$store.dispatch("searchLabtests", {
            searchText: this.labTestsSearchText,
          });
        } catch (e) {
          this.labTestList = [];
          console.log(e);
        }
      } else {
        this.labTestList = [];
      }
    },
    updateFrequency(m, a, n) {
      if (!this.selectedRX.frequency) {
        this.selectedRX.frequency = {
          morning: {
            nos: "",
          },
          afternoon: {
            nos: "",
          },
          evening: {
            nos: "",
          },
          night: {
            nos: "",
          },
        };
      }
      this.selectedRX.frequency.morning.nos = m;
      this.selectedRX.frequency.afternoon.nos = a;
      this.selectedRX.frequency.night.nos = n;
    },
    async addNewDrug(drug) {
      var rxDrug = {
        substanceName: drug.name,
        dosageFormName: drug.dosageForm,
        createdBy: this.user._id,
      };
      await this.$store.dispatch("addNewDrug", rxDrug);
      swal.fire({
        title: this.$t("message.Success!"),
        text: this.$t("message.Drug added Successfully"),
        type: "success",
      });
    },
    async addNewLabTest(labTest) {
      var newLabTest = {
        test: labTest.name,
      };
      await this.$store.dispatch("addNewLabTest", newLabTest);
      swal.fire({
        title: this.$t("message.Success!"),
        text: this.$t("message.Test Added Successfully"),
        type: "success",
      });
    },
    addNewDrugCard() {
      this.selectedRX = {
        name: "",
        frequency: {
          morning: {},
          afternoon: {},
          evening: {},
          night: {},
        },
      };
    },
    addNewRx() {
      this.SHOW_RX_SELECTION_MODAL = true;
    },
    addNewICDcode() {
      this.SHOW_ICD_SELECTION_MODAL = true;
    },
    addNewLabPrescription() {
      this.SHOW_LABTEST_SELECTION_MODAL = true;
    },
    addNewImagingPrescription() {
      this.SHOW_IMAGING_SELECTION_MODAL = true;
    },
    onRxSelectionModalClosed() {
      this.SHOW_RX_SELECTION_MODAL = false;
      this.selectedRX = null;
      this.drugsSearchText = null;
    },
    onIcdSelectionModalClosed() {
      this.SHOW_ICD_SELECTION_MODAL = false;
      this.selectedIcd = null;
      this.icdCodesSearchText = null;
    },
    onLabTestSelectionModalClosed() {
      this.SHOW_LABTEST_SELECTION_MODAL = false;
      this.selectedLabTest = null;
      this.labTestsSearchText = null;
    },
    onImagingSelectionModalClosed() {
      this.SHOW_IMAGING_SELECTION_MODAL = false;
      this.selectedImaging = null;
    },
    deleteDrugCard(index) {
      this.prescription.rx.splice(index, 1);
      if (this.prescription.rx.length == 0) {
        this.prescription.rx = [];
        this.drugList = this.frequentDrugs;
      }
    },
    deleteSelectedRx() {
      this.selectedRX = null;
    },
    deleteSelectedIcd() {
      this.selectedIcd = null;
    },
    deleteSelectedLabtest() {
      this.selectedLabTest = null;
    },
    addNewLabTestCard() {
      this.selectedLabTest = {
        name: "",
        comment: "",
        newTest: true,
      };
    },
    deleteLabCard(index) {
      this.prescription.labPrescription.splice(index, 1);
      if (this.prescription.labPrescription.length == 0) {
        this.labTests = [];
        this.labTestList = [];
      }
    },
    removeIcdCodeCard(index) {
      this.prescription.provisionalDiagnosis.icdCodes.splice(index, 1);
      if (this.prescription.provisionalDiagnosis.icdCodes.length == 0) {
        this.prescription.provisionalDiagnosis.icdCodes.icdCodes = [];
        this.icdCodesList = [];
      }
    },

    //Frequent drugs
    async toggleFrequentDrug(drugId) {
      try {
        if (this.isFrequentDrug(drugId)) {
          await this.$store.dispatch("removeFrequentDrug", {
            providerId: this.user._id,
            drugId: drugId,
          });
        } else {
          await this.$store.dispatch("addFrequentDrug", {
            providerId: this.user._id,
            drugId: drugId,
          });
        }

        this.getFrequenrDrugs();
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "error",
          title: "Oops!",
          text: this.$t("message.Could not add this drug to your favourites"),
          timer: 5000,
        });
      }
    },
    isFrequentDrug(drugId) {
      if (this.frequentDrugs && this.frequentDrugs.length > 0) {
        let drugs = this.frequentDrugs.filter((drug) => {
          return drug._id == drugId;
        });

        return drugs && drugs.length > 0;
      } else {
        return false;
      }
    },
    async getFrequenrDrugs() {
      try {
        this.frequentDrugs = await this.$store.dispatch(
          "getFrequentDrugs",
          this.user._id
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
  async mounted() {
    if (!this.prescription.provisionalDiagnosis) {
      this.prescription.provisionalDiagnosis = {
        notes: null,
        icdCodes: [],
      };
    }
    this.labTestList = this.$store.state.labTestList;
    await this.getFrequenrDrugs();
    this.drugList = this.frequentDrugs;

    try {
      this.provider = await this.$store.dispatch(
        "getUserById",
        this.appointment.provider.providerId
      );
    } catch (e) {
      console.log(e);
    }
    for (let image of this.imagingList) {
      this.specification[image.name] = [];
    }
  },
  beforeDestroy() {
    if (this.prescriptionListener) this.prescriptionListener.cancel();
  },
};
</script>
<style scoped>
.el-select {
  width: 100%;
}

/deep/.dosage-frequency .select-primary.el-select .el-input .el-input__inner {
  margin-top: 0;
}

/deep/.dosage-frequency .select-primary.el-select .el-input .el-input__suffix {
  height: 3em;
}

.label-style {
  font-size: 15px;
}

.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}

/deep/#followup-days {
  padding-right: 18px;
}

h6 {
  text-transform: none;
}

.prescription-section {
  margin-top: 1em;
}

/deep/.modal-content .modal-header {
  padding-bottom: 1rem;
}

/deep/ .IZ-select__item {
  border-bottom: 1px solid lightgrey;
}

/deep/ .IZ-select__menu {
  background: white;
  overflow: scroll;
  height: 70vh;
}
</style>
